import createVueComponent from '../createVueComponent';

const LampFloor = createVueComponent('LampFloorIcon', [
  ['path', { d: 'M9 2h6l3 7H6l3-7Z', key: 'wcx6mj' }],
  ['path', { d: 'M12 9v13', key: '3n1su1' }],
  ['path', { d: 'M9 22h6', key: '1rlq3v' }],
]);

export default LampFloor;
